<template lang="pug">
    .re-credit-card-edit-box.fis-express-billing-section
        template(v-if="showPaymentIframe")
            p We will try to charge you for $0.01 and refund back.
            .re-cart-billing-edit-box(v-if="showPaymentIframe")
                p Please fill in your billing details in the form below.
                iframe(ref="paymentIframe" :src="transactionSetup.url" height="700") Your browser does not support inline frames.
                re-button.re-back-button(@click="cancel") Cancel
        template(v-else)
            re-toast-alert.m-b-30(v-if="errorMessage" type="danger") {{ errorMessage }}
            re-button(v-if="!loadingPaymentFrame" @click="cancel") Back

        re-loading(v-if="loadingPaymentFrame")

</template>

<script>
import { getFirstErrorMessage } from '~/lib/axios'

const MIN_AMOUNT = 0.01

export default {
    name: 're-credit-card-form-fis-express',

    props: {
        location_id: {
            type: String,
        },
    },

    data: () => ({
        loadingPaymentFrame: true,
        showPaymentIframe: false,
        transactionSetup: null,
        returnUrl: `${window.addiesaas.url}/fis-express/transaction/return`,
        errorMessage: null,
        axiosConfig: null,
    }),

    created() {
        if (this.location_id) {
            this.axiosConfig = {
                headers: {
                    'X-Location': this.location_id,
                }
            }
        } else {
            this.errorMessage = 'Please select location before adding new payment card'
            this.loadingPaymentFrame = false
        }
    },

    mounted() {
        if (this.loadingPaymentFrame) {
            this.$nextTick(() => {
                this.mountPaymentForm()
            })
        }
    },

    beforeDestroy() {
        window.removeEventListener('message', this.receivePaymentFormMessage, false)
    },

    methods: {
        async mountPaymentForm() {
            const { data: transactionSetup } = await axios.post(
                `${window.addiesaas.url}/api/customer/fis-express/transaction/setup`,
                {
                    amount: MIN_AMOUNT,
                    redirect: this.returnUrl + '?location=' + this.location_id,
                },
                this.axiosConfig
            )

            this.transactionSetup = transactionSetup

            this.showPaymentIframe = true
            this.loadingPaymentFrame = false

            window.addEventListener('message', this.receivePaymentFormMessage, false)
        },

        async receivePaymentFormMessage(event) {
            if (event.origin == (new URL(this.returnUrl)).origin) {
                console.log(event.data)

                if (event.data.cancelled) {
                    this.cancel()
                    return
                }

                if (event.data.error) {
                    this.errorMessage = event.data.display_error || window.addiesaas.config.translations.fisexpress.transaction_not_authorized
                } else {
                    if (event.data.transaction_id) {
                        try {
                            await axios.post(
                                `${window.addiesaas.url}/api/customer/fis-express/biller/card`,
                                {
                                    transaction_id: event.data.transaction_id,
                                },
                                this.axiosConfig
                            )
                        } catch (e) {
                            this.showPaymentIframe = false
                            this.errorMessage = getFirstErrorMessage(e)
                            return
                        }

                        this.success()
                    }
                }
            }
        },

        success() {
            this.$emit('fetch')
            this.$emit('close')
        },

        cancel() {
            this.$emit('close')
        },
    }
}
</script>
